import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useAuth } from './useAuth';

const TOUR_KEY = 'carrier_tour_done';

export function useCarrierTour(
  carrierStatus: string | null,
  openMenus: (ids: string[]) => void,
) {
  const { user } = useAuth();

  useEffect(() => {
    if (
      user?.role !== 'carrier' ||
      carrierStatus === null ||
      localStorage.getItem(TOUR_KEY)
    ) return;

    const timer = setTimeout(() => {
      openMenus(['coreSettings', 'deliveryAgents']);
      setTimeout(() => {
        const driverObj = driver({
          showProgress: true,
          animate: true,
          overlayOpacity: 0.65,
          nextBtnText: 'التالي →',
          prevBtnText: '→ السابق',
          doneBtnText: 'ابدأ الآن ✓',
          progressText: '{{current}} من {{total}}',
          onDestroyStarted: () => { localStorage.setItem(TOUR_KEY, 'true'); driverObj.destroy(); },
          steps: [
            { popover: { title: 'مرحباً بك في QuBox 👋', description: 'سنرشدك خلال 5 خطوات أساسية لإعداد حسابك وبدء استقبال الشحنات.', side: 'over', align: 'center' } },
            { element: '#tour-cities', popover: { title: 'الخطوة 1 — المدن', description: 'ابدأ باختيار المدن التي تغطيها خدمة التوصيل لديك.', side: 'left', align: 'start' } },
            { element: '#tour-zones', popover: { title: 'الخطوة 2 — مناطق التوصيل', description: 'قسّم كل مدينة إلى مناطق لتسهيل توزيع الشحنات على المندوبين.', side: 'left', align: 'start' } },
            { element: '#tour-routes', popover: { title: 'الخطوة 3 — المسارات', description: 'أنشئ مسارات تربط بين مناطق التوصيل لتنظيم جولات المندوبين.', side: 'left', align: 'start' } },
            { element: '#tour-pricing', popover: { title: 'الخطوة 4 — أسعار التوصيل', description: 'حدد تعريفات الأسعار لكل مدينة أو منطقة توصيل.', side: 'left', align: 'start' } },
            { element: '#tour-drivers', popover: { title: 'الخطوة 5 — المندوبون', description: 'أضف مندوباً واحداً على الأقل لتفعيل حسابك واستقبال الشحنات.', side: 'left', align: 'start' } },
          ],
        });
        driverObj.drive();
      }, 350);
    }, 700);
    return () => clearTimeout(timer);
  }, [user?.role, carrierStatus]);
}
